import React, { useState } from 'react';
import { Box, Collapse, Typography, IconButton } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { InvTextField } from '../InvField';
import { IPD_COLORS } from '../../theme';

export function parsePayloadJson(value) {
  const raw = typeof value === 'string' ? value.trim() : '';
  if (!raw) return {};
  const parsed = JSON.parse(raw);
  if (parsed === null || typeof parsed !== 'object' || Array.isArray(parsed)) {
    throw new Error('Payload must be a JSON object');
  }
  return parsed;
}

export function formatPayloadForField(payload) {
  if (!payload || typeof payload !== 'object' || Object.keys(payload).length === 0) return '';
  try {
    return JSON.stringify(payload, null, 2);
  } catch {
    return '';
  }
}

/**
 * Collapsed optional JSON payload editor for master entities.
 */
export default function PayloadJsonField({ value, onChange, error, disabled = false }) {
  const [open, setOpen] = useState(Boolean(value?.trim()));

  return (
    <Box sx={{
      border: `1px solid ${IPD_COLORS.border}`,
      borderRadius: '10px',
      overflow: 'hidden',
    }}>
      <Box
        onClick={() => !disabled && setOpen(o => !o)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 1.5,
          py: 1,
          cursor: disabled ? 'default' : 'pointer',
          backgroundColor: 'rgba(13,35,63,0.03)',
        }}
      >
        <Typography sx={{ fontSize: 13, fontWeight: 600, color: IPD_COLORS.textPrimary }}>
          Advanced settings (JSON)
        </Typography>
        <IconButton size="small" tabIndex={-1} disabled={disabled}>
          {open ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
        </IconButton>
      </Box>
      <Collapse in={open}>
        <Box sx={{ p: 1.5, pt: 0 }}>
          <InvTextField
            value={value}
            onChange={onChange}
            label="class_payload / group_payload"
            placeholder='{ "storage_note": "Cold chain optional" }'
            multiline
            rows={4}
            disabled={disabled}
            error={error}
            helperText={error?.message || 'Leave empty to send {}. Must be valid JSON object.'}
          />
        </Box>
      </Collapse>
    </Box>
  );
}
